import ConnectingModal from './ConnectingModal';

export default ConnectingModal;